<div class="container-fluid vh-100">
  <div class="row vh-100 row-cols-1 row-cols-sm-2 row-cols-md-2">
    <div class="col-12">
      <div class="contents order-2 order-md-1">
        <div class="container">
          <div class="row align-items-center justify-content-center vh-100">
            <div class="col-md-7">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 auth-banner d-none d-md-block">
    </div>
  </div>
</div>
